const { forwardRef, useState, useImperativeHandle } = require('react');

import React, { useEffect } from 'react';

export const ModalHeader = ({ title, modalRef }) => {
    const handleCancel = () => {
        modalRef.current.close();
    };
    return (
        <div className='modal-header'>
            <h2 className='modal-title'>{title}</h2>
            <button type='button' className='btn close' onClick={() => handleCancel()} />
        </div>
    );
};

export const InfoTxt = ({ infoTxt }) => {
    return (
        <div className='info-txt'>
            <span className='ico-info'></span>
            <div style={{ marginTop: 4 }}>{infoTxt}</div>
        </div>
    );
};

const ModalRef = forwardRef(({}, ref) => {
    const [open, setOpen] = useState(false);
    const [size, setSize] = useState('small');
    const [element, setElement] = useState(null);

    function closeModal(e) {
        if (e.key === 'Escape') {
            setOpen(false);
        }
    }
    useEffect(() => {
        window.addEventListener('keydown', closeModal);
        return () => window.removeEventListener('keydown', closeModal);
    }, []);

    useImperativeHandle(ref, () => ({
        open: (
            // element: 모달에 보여줄 엘레먼트
            // - 헤더: <ModalHeader />
            // - 설명: <InfoTxt />
            element,
            // size: 모달의 크기 설정 ('small'이외 'large'로 처리)
            size,
        ) => {
            // TODO : pop-up 화면에서 화면의 scroll hidden 처리되면서 화면이 움직이는 현상 존재함, 스크롤이 사라지는 현상 존재함. 화면 이동시
            // document.body.style.overflowY = 'hidden';
            size && setSize(size);
            setElement(element);
            setOpen(true);
        },
        close: () => {
            // document.body.style.overflowY = 'unset';
            setOpen(false);
        },
    }));

    if (open) {
        return (
            <div className='modal-open'>
                {/* <div className='modal fade show' style={{ display: 'block', paddingTop: 60, paddingRight: 17 }}> */}
                <div className='modal fade show'>
                    <div className='modal-wrap'>
                        <div
                            className={
                                'modal-center ' +
                                (size == 'small' ? 'modal-s' : size == 'medium' ? 'modal-m' : 'modal-l')
                            }
                        >
                            <div className='modal-box'>{element && element}</div>
                        </div>
                    </div>
                </div>
                <div className='modal-back fade show'></div>
            </div>
        );
    } else {
        return <></>;
    }
});

export default ModalRef;
